import React from "react";
import { useIntl } from "react-intl";
import SeoHead from "~/components/seo/SeoHead";

interface ISignUpPageSeoProps {
  signingIn: boolean;
}

export default function SignUpPageSeo({ signingIn }: ISignUpPageSeoProps) {
  const intl = useIntl();

  return (
    <SeoHead
      title={
        signingIn
          ? intl.formatMessage({ defaultMessage: "Log In to Govlaunch", id: "IFXsLj" })
          : intl.formatMessage({ defaultMessage: "Sign Up for Govlaunch", id: "cWOAGP" })
      }
      description={
        signingIn
          ? intl.formatMessage({
              defaultMessage:
                "Sign in to search successful local government project examples, government technology solutions and more.",
              id: "s9mSWB",
            })
          : intl.formatMessage({
              defaultMessage:
                "Join the free wiki for local government innovation. Search successful project examples, government technology solutions and more.",
              id: "ZHSGor",
            })
      }
    />
  );
}
